import { render, staticRenderFns } from "./SingleSignupParent.vue?vue&type=template&id=2e70c814&"
import script from "./SingleSignupParent.vue?vue&type=script&lang=js&"
export * from "./SingleSignupParent.vue?vue&type=script&lang=js&"
import style0 from "./SingleSignupParent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports